import React, {FC} from 'react';
import styled from 'styled-components';

import {RendererOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {AsyncStatusesEnum} from '../../../../libs/shared/helpers/src/types/asyncStatuses';
import {flexCenter} from '../../../../libs/shared/ui/src/styles/mixins';
import {AsyncDataWithRetry} from '../../../helpers/asyncDataHelpers';
import {AsyncLoader, AsyncLoaderProps} from './asyncLoader';

/*
 * Props.
 */

export interface AsyncDataLoaderProps<T> extends Omit<AsyncLoaderProps, 'status' | 'error' | 'onRetryClick'> {
  className?: string;
  data: AsyncDataWithRetry<T>;
  children: RendererOf<T>;
}

/*
 * Styles.
 */

const StyledWrapper = styled.div`
  height: 100%;
  ${flexCenter};
  justify-content: center;
`;

/*
 * Component.
 */

export const AsyncDataLoader = <T,>({
  data,
  className,
  children: renderChildren,
  ...loaderProps
}: AsyncDataLoaderProps<T>): ReturnType<FC> => {
  if (data.status === AsyncStatusesEnum.LOADED) {
    return <>{renderChildren(data.data)}</>;
  }

  return (
    <StyledWrapper className={className}>
      <AsyncLoader
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...loaderProps}
        status={data.status}
        error={'error' in data ? data.error.message : undefined}
        onRetryClick={data.onRetry}
      />
    </StyledWrapper>
  );
};
